import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import TemplateDetailsPage, { getDefaultData, getDefaultUI } from 'components/pages/TemplateDetailsPage';
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";
import Classes, { CompanyAccount } from "model";
import { useEffect } from "react";

export default function CaptureTemplateDetailsOffetAcctDDOpen(props) {
  const context = useBCMSContext();
  const { branding } = context.state;
  const { options } = branding ?? {};
  BCMSRecord.globalControllerFor(Classes, context);
  const hasACHFromSection = options.ach_from_abi22 === "true";

  const data = BCMSStateManagerCRUD.init(getDefaultData())
  .update(["template", "transactionType"], "payment")
  .update([ "template", "secCode" ], "PPD Credit - Consumer Credit")
  .update([ "template", "name" ], "New Payroll")
  .update([ "template", "companyDiscretionaryData" ], "Bi-Weekly")
  .update([ "template", "companyEntryDescription" ], "Payroll")
  .update([ "template", "companyAccount" ], CompanyAccount.initByID(0))
  .submit();

  const ui = BCMSStateManagerCRUD.init(getDefaultUI())
  .update([ "showSecCode", "isActive" ], true)
  .update([ "showOneTimeACHModal", "isActive" ], false)
  .update([ "offsetAccountSelectIsActive", "isActive" ], true)
  .submit();

  useEffect(() => {
    Util.replaceDOMDataPointValues(branding);
  });

  if(!hasACHFromSection) {
    const message = `This capture is only shown when ABI22 branding option "One-Time ACH/Template - ACH From Section" is set to "Yes".`;
    return <CaptureNotShownView message={ message }/>;
  }
    
  return (
    <TemplateDetailsPage data={data} ui={ui} />
  );
}
